define([
    'lodash',
    'coreUtils',
    'componentsCore'
], function (
    _,
    coreUtils,
    componentsCore) {
    'use strict';

    function checkRequirements(siteData, compInfo) {
        const svgId = _.get(compInfo, ['properties', 'overrideMask', 'svgId']) || _.get(compInfo, ['design', 'background', 'mediaRef', 'mask', 'svgId']);

        if (svgId) {
            return _.compact([
                coreUtils.svg.createSvgFetchRequest(
                    siteData.serviceTopology.mediaRootUrl,
                    siteData,
                    svgId
                )
            ]);
        }
        return [];
    }

    componentsCore.dataRequirementsCheckerRegistrar.registerCheckerForCompType('wysiwyg.viewer.components.MediaPlayer', checkRequirements);
});
